module.exports = __webpack_public_path__ + "static/eduardo-0b7126e82ee37b0261ee403232a99811.png";